import { render } from "./StagesNew.vue?vue&type=template&id=43129573&scoped=true&lang=pug"
import script from "./StagesNew.vue?vue&type=script&lang=js"
export * from "./StagesNew.vue?vue&type=script&lang=js"

import "./StagesNew.vue?vue&type=style&index=0&id=43129573&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43129573"]])

export default __exports__